import { PRODUCTION_PROGRESS_MESSAGES } from '../app/utils/status-messages';

export const environment = {
    production: false,
    fastApiBaseUrl: 'https://builder-api.dev.mfg.com/api/v1',
    dynamoApiBaseUrl: 'https://quotenetapi.dev.mfg.com/api',
    companyGuidApiBaseUrl: 'https://quotenetapi.dev.mfg.com/',
    rfqIntakeUrl: 'https://quote.dev.mfg.com/rfq-intake',
    dashboardUrl: 'https://uatapp.mfg.com/#/dashboard/supplier/ecommerce',
    useNewFastApi: true,
    deploymentConfig: {
      maxAttempts: 42, // 7 minutes with 10-second intervals
      pollInterval: 10000, // 10 seconds
      progressMessages: PRODUCTION_PROGRESS_MESSAGES,
      accessibilityCheckDuration: 120000, // 2 minutes for website accessibility checking
      accessibilityCheckInterval: 30000 // 30 seconds between accessibility check messages (within 60s limit)
    },
    hostSuffix: '.dev.mfg.com',
    MIXPANEL_TOKEN: "821632dbab87d76ec9b24d3251deb7a1",
    MIXPANEL_SUPPLIER_ID_PREFIX: "UAT_",
    templateImageBaseUrl: 'https://dev-supplier-website-images.s3.us-east-1.amazonaws.com/template_images'
}; 